import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { useKeycloak } from '@eggplant/context'
import type {
  Error,
  Principal
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (response: Principal[]) => ReactElement
  onSuccess?: (response: Principal[]) => void
  onError?: (error: Error) => void
}

const GetSpaceUsersRequest = ({
  children,
  onSuccess,
  onError
}: Props) => {
  const { keycloak: keycloakInstance } = useKeycloak()
  const url = `${keycloakInstance.authServerUrl}/realms/${keycloakInstance.realm}/dai/v1/users/`

  return (
    <AuthenticatedDataRequest
      acceptType='application/json'
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      url={url}
    />
  )
}

export default GetSpaceUsersRequest
